const PRODUCT_INFO_PREFIX = 'hideProductInfo'

class ProductDetailsController {
  constructor (ProductService, IdsService, VehicleService, $scope, $window, $stateParams, $state, $sce, ProductUtilsService, I18n, $rootScope, $log) {
    'ngInject'
    this.isProcessing = true
    this.$window = $window
    this.$state = $state
    this.$scope = $scope
    this.$stateParams = $stateParams
    this.$rootScope = $rootScope
    this.$log = $log
    this.productService = ProductService
    this.idsService = IdsService
    this.vehicleService = VehicleService
    this.i18n = I18n
    this.ref = $stateParams.ref.toString()
    this.group = $stateParams.group
    this.$sce = $sce
    this.productUtilsService = ProductUtilsService
    this.product = {
      title: ''
    }
    if (this.group) {
      this.selectedProduct = Object.assign({}, this.group.find((element) => {
        return element.ref === this.ref
      }))
    }
    this.spaceWarning = ''
    this.loaded = this.init()

    $window.scrollTo(0, 0)
  }

  init () {
    this.isBuyable = false
    return this.vehicleService.getCurrentSelectedVehicle()
    .then((v) => {
      if (!v) {
        return Promise.reject('Unable to get current selected vehicle')
      }
      this.vehicle = v
      return this.productService.getProduct(this.ref, this.vehicle.vin, this.i18n.getLanguage())
    })
    .then((product) => {
      this.product = product
      this.screenshots = this.productUtilsService.getScreenShots(product.screenshot.split('#'))
      this.size = Number(product.size) / 1048576
      this.productInfo()
      if (this.product.infoCode === 7 && this.productUtilsService.isContent(this.product)) {
        return this.productService.getIsPreviouslyInstalled(this.ref, this.vehicle.vin)
      } else {
        return Promise.resolve(false)
      }
    })
    .then((userOwnLastestVersion) => {
      if (userOwnLastestVersion) {
        this.infoCode = 0
      }
      this.isBuyable = this.productUtilsService.isBuyable(this.product, this.vehicle, userOwnLastestVersion)
      this.isProcessing = false
      this.safeApply()
      return Promise.resolve()
      .then(() => {
        this.checkDeviceTotalSpace()
      })
    }, (err) => {
      this.$log.error(err)
      this.info = null
      this.error = err
      this.product = null
      this.isProcessing = false
      this.safeApply()
      return Promise.reject()
    })
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }

  getDuration (item) {
    return this.productUtilsService.getDuration(item, true)
  }

  get isPromotion () {
    return this.productUtilsService.isPromotion(this.product)
  }

  get actualPrice () {
    return this.productUtilsService.getActualPrice(this.product)
  }

  get isPackOrBundle () {
    return this.productUtilsService.isPackOrBundle(this.product)
  }

  get buttonLabel () {
    return this.productUtilsService.getButtonLabel(this.product)
  }

  get warningMessage () {
    return this.productUtilsService.getWarningMessage(this.product, this.spaceWarning, this.vehicle.huType)
  }

  get packContent () {
    return this.productUtilsService.getPackContent(this.product)
  }

  changeProduct () {
    if (this.selectedProduct) {
      this.ref = this.selectedProduct.ref
      this.isProcessing = true
      this.$state.go('vehicle.productDetails', {ref: this.ref, group: this.group})
    }
  }

  goPurchase () {
    const productId = this.ref
    this.$state.go('managePurchase.myPurchase', {productId})
  }

  productInfo () {
    const huType = this.vehicle.huType
    if (huType === 'MM12') {
      this.info = {
        cookieKey: PRODUCT_INFO_PREFIX + '.mm12.' + this.ref,
        message: 'productDetails.infoMessage.info_mm12'
      }
    } else if (huType === 'RADNAV') {
      this.info = {
        cookieKey: PRODUCT_INFO_PREFIX + '.radnav.' + this.ref,
        message: 'productDetails.infoMessage.info_radnav'
      }
    }
  }

  checkDeviceTotalSpace () {
    if (this.product.tomtomId && (this.product.tomtomId.substring(0, 4) === 'map/' || this.product.tomtomId.substring(0, 11) === 'mappackage_')) {
      console.log('Map ' + this.product.ref + ' has tomtomId = ' + this.product.tomtomId)
      this.productService.checkIfMapIsInstallable(this.vehicle.vin, this.product.ref)
      .then((response) => {
        console.log('This map is installable: ' + response)
        if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
          this.spaceWarning = 'map'
          this.isBuyable = false
        } else if (response === 'DEVICE_UNKNOWN_BY_TOMTOM' || response === 'DEVICE_UNKNOWN_BY_SIG') {
          this.spaceWarning = 'pds'
          this.isBuyable = false
        }
      })
    } else if (this.product.packageNameMus && (this.product.packageNameMus.substring(0, 4) === 'map/' || this.product.packageNameMus.substring(0, 11) === 'mappackage_')) {
      console.log('MUS ' + this.product.ref + ' has packageNameMus = ' + this.product.packageNameMus)
      this.productService.checkIfLatestMapIsInstallable(this.vehicle.vin, this.ref)
      .then((response) => {
        console.log('The latest map available is installable: ' + response)
        if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
          this.spaceWarning = 'mus'
          this.isBuyable = false
        } else if (response === 'DEVICE_UNKNOWN_BY_TOMTOM' || response === 'DEVICE_UNKNOWN_BY_SIG') {
          this.spaceWarning = 'pds'
          this.isBuyable = false
        }
      })
    }
  }
}

export default ProductDetailsController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/product-details/product-details.controller.js